import styled from 'styled-components';

import { scale150, scale170, spaceS, xdlColorBackground, xdlColorBorderSoft } from '@xingternal/tokens';

export const Container = styled.div`
  align-items: center;
  background: ${xdlColorBackground};
  border-bottom: 1px solid ${xdlColorBorderSoft};
  display: flex;
  min-height: ${scale170};
  justify-content: space-between;
  padding: 0 ${spaceS};
`;

export const Title = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const PlaceboButton = styled.div`
  width: ${scale150};
`;
